import { Injectable } from '@angular/core';

import { ConfigParserService } from './config-parser.service';

export interface SwayConfig {
    analyticsBatchSize: number;
    apiUrl: string;
    myEndpoint: string;
    thumbnailsEnabled: boolean;
    uploadMaxFileSize: number;
    uploadSupportedExtensions: Array<string>;
}

@Injectable({
    providedIn: 'root'
})
export class SwayConfigService {
    public readonly config: SwayConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<SwayConfig>('swayConfig') || {
            analyticsBatchSize: 1,
            apiUrl: null,
            myEndpoint: null,
            thumbnailsEnabled: false,
            uploadMaxFileSize: 0,
            uploadSupportedExtensions: []
        };
    }
}
